import React from "react";
import "./SupportButton.css";

function SupportButton({ ariaLabel, title }) {
  const handleClick = () => {
    window.open("https://t.me/aldeabitcoin", "_blank", "noopener,noreferrer");
  };

  return (
    <button
      className="support-button"
      onClick={handleClick}
      aria-label={ariaLabel}
      title={title}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </button>
  );
}

export default SupportButton;

